import { writable, derived, get } from "svelte/store";
export function createElementTrackStore() {
    let attachedTrack;
    const elementStore = writable(null);
    const trackStore = writable(null);
    const maybeDetachTrack = () => {
        const element = get(elementStore);
        if (attachedTrack) {
            attachedTrack.detach(element, attachedTrack);
            attachedTrack = null;
        }
    };
    const attachTrack = () => {
        const track = get(trackStore);
        const element = get(elementStore);
        if (track && track !== attachedTrack) {
            maybeDetachTrack();
            attachedTrack = track;
            track.attach(element, track);
        }
    };
    /**
     * We create a derived store whose value changes when either the element or
     * its corresponding track changes.
     */
    const store = derived([elementStore, trackStore], ([$element, $track]) => {
        return { element: $element, track: $track };
    });
    const unsubscribe = store.subscribe(($props) => {
        if ($props.element && $props.track) {
            attachTrack();
        }
    });
    return {
        subscribe: store.subscribe,
        destroy: () => {
            maybeDetachTrack();
            unsubscribe();
        },
        setElement: (element) => {
            elementStore.set(element);
        },
        setTrack: (track) => {
            if (track !== get(trackStore)) {
                trackStore.set(track);
            }
        },
    };
}
//# sourceMappingURL=ElementTrackStore.js.map